import React, { useState } from "react";
import AddonsTab from "./Addons";
import BillingTab from "./Billing";

// The profile page: Learners | Add-ons | Billing. Learners is the existing page (passed in); the other two are new.
const TABS = [["learners", "Learners"], ["addons", "Add-ons"], ["billing", "Billing"]];

export default function ProfileTabs({ token, learners, goPlans, onChanged }) {
  const [tab, setTab] = useState(() => {
    const t = new URLSearchParams(window.location.search).get("tab");
    return TABS.some(([k]) => k === t) ? t : "learners";
  });
  const pick = (t) => {
    setTab(t);
    try { const u = new URL(window.location.href); u.searchParams.set("page", "profiles"); u.searchParams.set("tab", t); window.history.replaceState({}, "", u); } catch { /* the tab still switches */ }
  };
  const onKey = (e) => {
    const i = TABS.findIndex(([k]) => k === tab);
    const next = e.key === "ArrowRight" ? (i + 1) % TABS.length : e.key === "ArrowLeft" ? (i + TABS.length - 1) % TABS.length : null;
    if (next === null) return;
    e.preventDefault(); pick(TABS[next][0]);
    document.getElementById(`tab-${TABS[next][0]}`)?.focus();
  };
  return (
    <div className="space-y-5" data-testid="profile-tabs">
      <div className="flex gap-1 border-b border-sand-300" role="tablist" aria-label="Profile" onKeyDown={onKey}>
        {TABS.map(([k, label]) => (
          <button key={k} id={`tab-${k}`} type="button" role="tab" aria-selected={tab === k} aria-controls={`panel-${k}`} tabIndex={tab === k ? 0 : -1} onClick={() => pick(k)} data-testid={`tab-${k}`}
            className={`min-h-[44px] border-b-2 px-4 text-sm font-semibold focus:outline-none focus-visible:ring-2 focus-visible:ring-gold-500 ${tab === k ? "border-forest-700 text-forest-700" : "border-transparent text-foreground/65 hover:text-forest-700"}`}>{label}</button>))}
      </div>
      <div id={`panel-${tab}`} role="tabpanel" aria-labelledby={`tab-${tab}`}>
        {tab === "learners" && learners}
        {tab === "addons" && <AddonsTab token={token} goPlans={goPlans} onChanged={onChanged} />}
        {tab === "billing" && <BillingTab token={token} goPlans={goPlans} onChanged={onChanged} />}
      </div>
    </div>
  );
}
